import { render } from "./TripleItem.vue?vue&type=template&id=017ed1d2&scoped=true"
import script from "./TripleItem.vue?vue&type=script&lang=js"
export * from "./TripleItem.vue?vue&type=script&lang=js"

import "./TripleItem.vue?vue&type=style&index=0&id=017ed1d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-017ed1d2"

export default script